import { ReactComponent as ControlsIcon } from 'images/controlsIcon.svg';
import { ReactComponent as FullScreenIcon } from 'images/fullscreenIcon.svg';
import { ReactComponent as CollapseFullScreenIcon } from 'images/collapseFullScreenIcon.svg';
import { useStores } from 'index';
import React, { useState } from 'react';
import screenfull from 'screenfull';
import { IconButton, SettingsWrapper } from './DashboardSettingsStyles';

export const DashboardSettings = () => {
  const liveDashboardStore = useStores().liveDashboardStore;
  const [fullscreen, setFullscreen] = useState<{ icon: JSX.Element }>({
    icon: <FullScreenIcon />,
  });

  const changeFullScreen = (): void => {
    if (screenfull.isFullscreen) {
      setFullscreen({
        icon: <FullScreenIcon />,
      });
    } else {
      setFullscreen({
        icon: <CollapseFullScreenIcon />,
      });
    }

    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  };

  return (
    <SettingsWrapper>
      <IconButton onClick={() => liveDashboardStore.setIsSettingsMenuVisible(true)} data-testid='settings-button'>
        <ControlsIcon />
      </IconButton>
      <IconButton onClick={changeFullScreen} data-testid='fullscreen-button'>
        {fullscreen.icon}
      </IconButton>
    </SettingsWrapper>
  );
};
